/* eslint-disable @typescript-eslint/no-empty-function */
import {
  AfterViewInit,
  Component,
  EventEmitter,
  forwardRef,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormControl,
  NgControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  selector: 'dcs-text-field',
  templateUrl: './dcs-text-field.component.html',
  styleUrls: ['./dcs-text-field.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DcsTextFieldComponent),
      multi: true,
    },
  ],
})
export class DcsTextFieldComponent
  implements OnInit, ControlValueAccessor, AfterViewInit {
  @Input()
  name: string;
  @Input()
  type: string;
  @Input()
  label: string;
  @Input()
  placeholder: string;
  @Input()
  helpertext: string;
  @Input()
  invalidtext: string;
  @Input()
  required: unknown;
  @Input()
  disabled: unknown;
  @Input()
  dsDisabled: unknown;
  @Input()
  value: string;
  @Output()
  valueChange: EventEmitter<unknown> = new EventEmitter();

  control: AbstractControl;

  public get invalid(): boolean {
    return this.control?.touched ? this.control.invalid : false;
  }

  constructor(private injector: Injector) {}
  ngOnInit(): void {}

  // The form control is only set after initialization
  ngAfterViewInit(): void {
    const ngControl: NgControl = this.injector.get(NgControl, null);
    if (ngControl) {
      this.control = ngControl.control as FormControl;
    } else {
      // Component is missing form control binding
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: any = () => {};
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onTouch: any = () => {};
  val = '';

  set valueSetter(val) {
    if (val !== undefined && this.val !== val) {
      this.val = val;
      this.onChange(val);
      this.onTouch(val);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  writeValue(value: any) {
    this.value = value;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  registerOnTouched(fn: any) {
    this.onTouch = fn;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onDsChange(event: any) {
    const value = event.detail.value;
    this.valueSetter = value;
    // // this.dsChange.emit(event);
    this.valueChange.emit(value);

    // this.control.setValue(value);
    // this.control.markAsTouched();
    // this.control.markAsDirty();
  }
}
